/**
 * Entries API client.
 */
import { apiGet, apiPost, apiPut } from './client';
import type {
  EntryCreateResponseDto,
  EntryDetailDto,
  EntryUpdateRequestDto,
  SelectionsUpdateRequestDto,
  SubmitEntryRequestDto,
  SubmitEntryResponseDto,
  ProcessingStatusDto,
  EntryValidationResultDto,
} from './types';

export const entriesApi = {
  /**
   * Create a new draft entry.
   */
  createDraft: (trialEventId: string, request?: { handlerEmail?: string; ownerEmail?: string }) =>
    apiPost<EntryCreateResponseDto>(`/trial-events/${trialEventId}/entries`, request ?? {}),

  /**
   * Get an entry by ID.
   */
  getById: (trialEventId: string, entryId: string) =>
    apiGet<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}`),

  /**
   * Update entry fields (dog, contact, emergency contact, fees).
   */
  update: (trialEventId: string, entryId: string, data: EntryUpdateRequestDto, etag?: string) =>
    apiPut<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}`, data, {
      headers: etag ? { 'If-Match': etag } : undefined,
    }),

  /**
   * Atomically replace the actual-handler/run aggregate read at this ETag.
   */
  updateSelections: (trialEventId: string, entryId: string, selections: SelectionsUpdateRequestDto, etag: string) =>
    apiPut<EntryDetailDto>(`/trial-events/${trialEventId}/entries/${entryId}/selections`, selections,
      { headers: { 'If-Match': etag } }),

  validate: (trialEventId: string, entryId: string) =>
    apiPost<EntryValidationResultDto>(`/trial-events/${trialEventId}/entries/${entryId}/validate`, {}),

  /**
   * Submit an entry.
   */
  submit: (trialEventId: string, entryId: string, request: SubmitEntryRequestDto) =>
    apiPost<SubmitEntryResponseDto>(`/trial-events/${trialEventId}/entries/${entryId}/submit`, request),

  /**
   * Get processing status (PDF/email status).
   */
  getProcessingStatus: (entryId: string) =>
    apiGet<ProcessingStatusDto>(`/admin/entries/${entryId}/processing-status`),
};
